export const getOtpForReset = (builder) => ({
    getOtpForReset: builder.mutation({
      query: (credentials) => ({
        url: '/forgot_password',
        method: 'POST',
        body: credentials,
      }),
    }),
  });